import React from "react";
import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { Box, TextField } from "@material-ui/core";
import { m } from "../../utils/i18n";

// ✅ Autocomplete import
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 280,
  },
  selectEmpty: {
    marginTop: theme.spacing(5),
  },
  /* root wrapper for the TextField */
  bigInputRoot: {
    "& .MuiOutlinedInput-root": {
      height: 64, //  overall height (48 default)
      fontSize: "1.25rem", // text inside the input
      lineHeight: 1.4,
      "& input": {
        padding: "22px 14px", //  vertical padding to keep text centred
      },
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "1.1rem", // label & placeholder
    },
  },

  /* each option inside the popup list */
  bigOption: {
    fontSize: "1.2rem",
    lineHeight: 1.5,
    minHeight: 48, // taller rows (optional)
  },

  responsiveWidth: {
    width: 440,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

export const RadioGroupStep = ({
  formData,
  setForm,
  setFormValues,
  navigation,
  stepData,
}) => {
  const { radioGroup } = stepData.params;
  const { options } = radioGroup;
  const classes = useStyles();

  // Set selected object from value
  const selectedOption =
    options.find((opt) => opt.value === formData[radioGroup.value]) || null;

  const handleChange = (event, newValue) => {
    const updatedFormData = { ...formData };
    const selectedValue = newValue ? newValue.value : "";

    updatedFormData[radioGroup.value] = selectedValue;
    setFormValues(updatedFormData);
  };

  return (
    <Container>
      <Box textAlign="center">
        <FormControl className={classes.formControl}>
          <Autocomplete
            className={classes.responsiveWidth}
            id={radioGroup.name}
            options={options}
            getOptionLabel={(option) => option.label || ""}
            value={selectedOption}
            onChange={handleChange}
            popupIcon={<ArrowDropDownIcon fontSize="large" />}
            classes={{ option: classes.bigOption }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={m("common.select.placeholder")}
                className={classes.bigInputRoot}
              />
            )}
          />
        </FormControl>
      </Box>
    </Container>
  );
};
